import {client} from './services/client'

export  const blogs = {
    namespaced:true,
    state:{
        blogs:[],
        blogloading:true,
    },
    mutations: {
        SET_BLOG (state,blogs){
            state.blogs = blogs
        },
        SET_BLOGLOADING (state,value){
            state.blogloading = value
        },


    },
    actions: {
        getBlog({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/blogs/get',
                })
                    .then((response)=>{
                        let blogs = response.data.blogs;
                       // console.log(blogs);
                        commit('SET_BLOG',blogs)
                        commit('SET_BLOGLOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        setBlog({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/blogs/save',
                    data:data,
                })
                    .then((response)=>{
                        let blogs = response.data.blogs;
                        commit('SET_BLOG',blogs);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteBlog({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/blogs/delete/'+id,
                })
                    .then((response)=>{
                        let blogs = response.data.blogs;
                        commit('SET_BLOG',blogs);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getBlog: state  => {
            return state.blogs
        },
    }
};
